"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Check = _interopRequireDefault(require("@honeybook/icons/dist/icons/Check16"));
var _LineHorizontal = _interopRequireDefault(require("@honeybook/icons/dist/icons/LineHorizontal16"));
var _MockPrintCheckboxButton = _interopRequireDefault(require("./MockPrintCheckboxButton"));
var _HBCheckbox = require("./HBCheckbox.styles");
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _useBuildTestIdInternal = require("../common/internal/useBuildTestIdInternal");
var HBCheckbox = function HBCheckbox(_ref) {
  var id = _ref.id,
    name = _ref.name,
    testIdName = _ref.testIdName,
    checked = _ref.checked,
    disabled = _ref.disabled,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'md' : _ref$size,
    customTheme = _ref.customTheme,
    onChange = _ref.onChange,
    className = _ref.className,
    onBlur = _ref.onBlur,
    onKeyPress = _ref.onKeyPress,
    testId = _ref.testId,
    _ref$hideFocusAndHove = _ref.hideFocusAndHoverStyles,
    hideFocusAndHoverStyles = _ref$hideFocusAndHove === void 0 ? false : _ref$hideFocusAndHove,
    tabIndex = _ref.tabIndex,
    _ref$indeterminate = _ref.indeterminate,
    _indeterminate = _ref$indeterminate === void 0 ? false : _ref$indeterminate,
    margin = _ref.margin;
  var finalTestId = (0, _useBuildTestIdInternal.useBuildTestIdInternal)({
    testId: testId,
    identifier: testIdName || id || name,
    suffix: 'checkbox',
    componentName: 'HBCheckbox'
  });
  var indeterminate = _indeterminate && !checked;
  var isActive = checked || indeterminate;
  var Icon = indeterminate ? _LineHorizontal["default"] : _Check["default"];
  var iconJSX = /*#__PURE__*/_react["default"].createElement(Icon, {
    color: (customTheme === null || customTheme === void 0 ? void 0 : customTheme.color) || _colors["default"].white
  });
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_HBCheckbox.Checkbox, {
    isDisabled: disabled,
    size: size,
    $margin: margin
  }, /*#__PURE__*/_react["default"].createElement(_HBCheckbox.StyledCheckbox, null, /*#__PURE__*/_react["default"].createElement(_HBCheckbox.Input, {
    ref: function ref(el) {
      if (el) {
        el.indeterminate = indeterminate;
      }
    },
    "data-testid": finalTestId,
    type: "checkbox",
    id: id,
    name: name,
    checked: checked,
    $isActive: isActive,
    disabled: disabled,
    customTheme: customTheme,
    onChange: onChange,
    className: className,
    onBlur: onBlur,
    onKeyPress: onKeyPress,
    hideFocusAndHoverStyles: hideFocusAndHoverStyles,
    tabIndex: tabIndex,
    "aria-checked": checked ? 'true' : indeterminate ? 'mixed' : 'false'
  }), /*#__PURE__*/_react["default"].createElement(_HBCheckbox.CheckedIcon, {
    $isActive: isActive,
    isDisabled: disabled
  }, iconJSX))), /*#__PURE__*/_react["default"].createElement(_MockPrintCheckboxButton["default"], {
    size: size,
    color: customTheme === null || customTheme === void 0 ? void 0 : customTheme.background,
    isActive: isActive,
    margin: margin
  }, iconJSX));
};
var _default = exports["default"] = HBCheckbox;
//# sourceMappingURL=HBCheckbox.js.map